export default [

  {
    path: '/my-approvals',
    name: 'MyApprovalsSingleLayout',
    redirect: { name: 'MyApprovalsSalesList' },
    component: () => import('pages/my-approvals/_layouts/MyApprovalsSingleLayout.vue'),
    children: [
      {
        path: 'sales',
        name: 'MyApprovalsSalesList',
        component: () => import('pages/my-approvals/tabs/MyApprovalsSalesList.vue'),
        meta: { slug: 'sales', useOverlay: true }
      },
      {
        path: 'contracts',
        name: 'MyApprovalsContractsList',
        component: () => import('pages/my-approvals/tabs/MyApprovalsContractsList.vue'),
        meta: { slug: 'contracts', useOverlay: true }
      }
    ]
  }
]
